import { render } from "./AuthFormRegister.vue?vue&type=template&id=58daa5dc&scoped=true"
import script from "./AuthFormRegister.vue?vue&type=script&lang=ts"
export * from "./AuthFormRegister.vue?vue&type=script&lang=ts"

import "./AuthFormRegister.vue?vue&type=style&index=0&id=58daa5dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58daa5dc"

export default script